exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-team-member-template-tsx": () => import("./../../../src/templates/teamMemberTemplate.tsx" /* webpackChunkName: "component---src-templates-team-member-template-tsx" */),
  "component---src-templates-therapy-type-template-tsx": () => import("./../../../src/templates/therapyTypeTemplate.tsx" /* webpackChunkName: "component---src-templates-therapy-type-template-tsx" */)
}

